import service from '../services/index';

export default {
  namespaced: true,
  state: {
    showModalCompletarPerfil: false,
  },

  getters: {
    getShowModalCompletarPerfil: state => state.showModalCompletarPerfil,
  },

  mutations: {
    setShowModalCompletarPerfil(state, value) {
      state.showModalCompletarPerfil = value;
    },
  },

  actions: {
    async verificarPerfilCompleto({ commit }) {
      if (sessionStorage.getItem('modalPerfilCompletado')) return;
      try {
        const response = await service.getPerfilConsultorCompletar();
        const data = response?.data?.data || {};
        const completo = data?.completo;
        if (completo === false) {
          commit('setShowModalCompletarPerfil', true);
          sessionStorage.setItem('modalPerfilCompletado', '1');
        }
      } catch(e) {
        // silencioso: no interrumpir el flujo de login
      }
    },
  },
};
